import './PageNotFound.css';

function PageNotFound({ onBack, statusError = '404', textError = '' }) {
  return (
    <main>
      <section className="pageNotFound">
        <h1 className="pageNotFound__title">{statusError}</h1>
        <p className="pageNotFound__text">{textError}</p>
        <button type="button" onClick={onBack} className="pageNotFound__button">
          Назад
        </button>
      </section>
    </main>
  );
}

export default PageNotFound;
